// extracted by mini-css-extract-plugin
module.exports = {"hotel":"accommodations_hotel__3ZTvV","hotelList":"accommodations_hotelList__35oVp"};